import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import l from "./index289.js";
const c = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, o, p, m, f, i) {
  return e(), t("svg", n, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 2.25c5.278 0 9.593 4.2 9.746 9.474l.004.276c0 5.278-4.2 9.593-9.474 9.746L12 21.75c-5.278 0-9.593-4.2-9.746-9.474L2.25 12c0-5.278 4.2-9.593 9.474-9.746Zm0 1.5-.244.004c-4.453.128-8.006 3.78-8.006 8.235l.004.255c.128 4.453 3.78 8.006 8.235 8.006l.255-.004c4.453-.128 8.006-3.78 8.006-8.235l-.004-.255A8.25 8.25 0 0 0 12 3.75ZM9.616 8.567l.084.073 2.3 2.299 2.3-2.3a.75.75 0 0 1 1.133.977l-.073.084-2.299 2.3 2.3 2.3a.75.75 0 0 1-.977 1.133l-.084-.073-2.3-2.299-2.3 2.3a.75.75 0 0 1-1.133-.977l.073-.084 2.299-2.3-2.3-2.3a.75.75 0 0 1 .977-1.133Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(c, [["render", s]]);
export {
  u as default
};
